import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

const samplePerformanceData = [
  { test: 'Test 1', score: 75 },
  { test: 'Test 2', score: 82 },
  { test: 'Test 3', score: 68 },
  { test: 'Test 4', score: 90 },
  { test: 'Test 5', score: 85 },
];

function PerformanceTracker() {
  return (
    <div className="performance-card">
      <h2 style= {{
        color : "var(--h2-heading-color)",
        textAlign: 'center',
        marginBottom: '2rem'
        }}>
        📈 Performance Tracker</h2>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={samplePerformanceData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="test" />
          <YAxis domain={[0, 100]} />
          <Tooltip />
          <Line type="monotone" dataKey="score" stroke="#007BFF" strokeWidth={3} activeDot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default PerformanceTracker;
